<script setup></script>
<template>
  <div class="column">
    <slot></slot>
  </div>
</template>
<style scoped>
.column {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
}
</style>
